import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-navbar-item" }
const _hoisted_2 = { class: "_flexcol _pa-2 _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_drawer_header = _resolveComponent("drawer-header")
  const _component_mobile_navigation_list = _resolveComponent("mobile-navigation-list")
  const _component_mobile_navigation_separator = _resolveComponent("mobile-navigation-separator")
  const _component_currency_selector = _resolveComponent("currency-selector")
  const _component_theme_selector = _resolveComponent("theme-selector")
  const _component_language_selector = _resolveComponent("language-selector")
  const _component_drawer = _resolveComponent("drawer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_button, {
      width: "narrow",
      theme: "default",
      "aria-label": _ctx.Resources.Layout.NavigationMenuTriggerLabel,
      onClick: $options.onOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_icon, {
          name: "bars",
          size: "lg",
          "is-fixed-width": ""
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["aria-label", "onClick"]),
    _createVNode(_component_drawer, {
      "is-open": _ctx.isDrawerOpen,
      onClose: $options.onClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_drawer_header, { onClose: $options.onClose }, null, 8 /* PROPS */, ["onClose"]),
        _createElementVNode("div", null, [
          ($options.hasNavigationItems)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_mobile_navigation_list, {
                  title: $options.navigationTitle,
                  navigation: $options.navigationItems
                }, null, 8 /* PROPS */, ["title", "navigation"]),
                _createVNode(_component_mobile_navigation_separator)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_mobile_navigation_list, {
            title: _ctx.Resources.Homepage.ExploreSectionTitle,
            navigation: $options.exploreItems
          }, null, 8 /* PROPS */, ["title", "navigation"]),
          _createVNode(_component_mobile_navigation_separator),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_currency_selector, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.DisplayCurrenciesLabel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            ($options.isDarkModeEnabled)
              ? (_openBlock(), _createBlock(_component_theme_selector, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Layout.ThemeSelectorLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_language_selector, {
              "display-name": _ctx.Resources.Layout.LanguageSelectorModalLabel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Layout.LanguageSelectorModalLabel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["display-name"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "onClose"])
  ]))
}